<!--
 * @Author: your name
 * @Date: 2019-12-17 10:58:47
 * @LastEditTime : 2019-12-26 17:38:53
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /search_component/src/components/showcase.vue
 -->
<template>
  <div>
    <div v-if="items.applications.length !== 0">
      <el-row
        :gutter="30"
        v-for="(application, index) of items.applications"
        :key="index + 'app'"
      >
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
          class="product-category"
          >
          {{ application.application }}
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
          v-for="(product, index) of application.products"
          v-bind:key="index + product.productSku"
          align="center"
        >
          <card :product="product" :searchParams="searchParams" />
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <h2 style="color:red">
        Sorry. Currently no option under this product is compatible with your
        vehicle. Our team will be notified and we will consider adding the
        compatible products later.
      </h2>
    </div>
  </div>
</template>

<script>
import card from "./card";
export default {
  name: "showcase",
  props: ["items","searchParams"],
  components: {
    card
  }
};
</script>

<style lang="less" scoped>
.el-col {
  // margin-bottom: 20px;
  display: -webkit-box!important;
  display: -webkit-flex!important;
  display: -ms-flexbox!important;
  display: flex!important;
  -webkit-box-align: stretch!important;
  -webkit-align-items: stretch!important;
  -ms-flex-align: stretch!important;
  align-items: stretch!important;
}
.product-category {
  text-align: left;
  font-size: 18px;
  color: #000000;
  position: relative !important;
}
</style>
